import React, { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { RelationshipsEmptyState, RelationshipsPanelViewer } from '../../../../../modernization-common/relationships';
import { DRAWER_MODE } from '../../../../../modernization-common/side-panel/const';
import { isVideoTaskAtom } from '../../../atoms/annotation-atoms';
import { selectedAnnotationRelationshipsAtom } from '../../../atoms/relationship-atoms';
import { allAnnotationMapAtom } from '../../../atoms/side-panel-atoms';
import { useRelationshipHandlers } from '../../side-panel/hooks/use-relationship-handlers';
export const RelationshipsPanel = () => {
  const relationships = useAtomValue(selectedAnnotationRelationshipsAtom);
  const allAnnotationsMap = useAtomValue(allAnnotationMapAtom);
  const isVideoTask = useAtomValue(isVideoTaskAtom);
  const {
    createRelationship,
    editRelationship,
    deleteRelationship
  } = useRelationshipHandlers({
    drawerMode: DRAWER_MODE.STACKED_DRAWER
  });
  const getTargetDisplayName = useCallback((annotationId: string): string => {
    const annotation = allAnnotationsMap[annotationId];
    if (!annotation) {
      return annotationId;
    }
    return `${annotation.annotation.annotationLabel.title}[${annotationId}]`;
  }, [allAnnotationsMap]);
  if (relationships.length === 0) {
    return <RelationshipsEmptyState onCreateRelationship={createRelationship} />;
  }
  return <RelationshipsPanelViewer relationships={relationships} getTargetDisplayName={getTargetDisplayName} isVideoTask={isVideoTask} onDeleteRelationship={deleteRelationship} onCreateRelationship={createRelationship} onEditRelationship={editRelationship} readOnly={false} />;
};